module.exports = __webpack_public_path__ + "static/img/autogood2.09043b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/autogood2.png
// module id = EHZA
// module chunks = 1